import { render, staticRenderFns } from "./training-answer-page-background.vue?vue&type=template&id=4c28ebcd&scoped=true&"
import script from "./training-answer-page-background.vue?vue&type=script&lang=js&"
export * from "./training-answer-page-background.vue?vue&type=script&lang=js&"
import style0 from "./training-answer-page-background.vue?vue&type=style&index=0&id=4c28ebcd&scoped=true&lang=scss&"
import style1 from "./training-answer-page-background.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c28ebcd",
  null
  
)

export default component.exports